import React from 'react';

import Layout from '../components/layout/Layout';
import View from '../components/partners/apps/View';

const appView = (props) => {
  const { app, similarApps } = props.pageContext;

  return (
    <>
      <Layout header="light">
        <View app={app} similarApps={similarApps} />
      </Layout>
    </>
  );
};

export default appView;
